// Б.2.a: Цифровое завещание — EOT-эффект на носителе.
// В конце КАЖДОГО хода (после Ф5): юнит-носитель умирает, Герой владельца
// получает хил, равный 50% от MAX ХП юнита-носителя (с учётом Модов),
// округление в большую сторону. (Этап 56.48: было ТЕКУЩЕГО ХП — фикс под текст.)
//
// Правила (из задания Б.2.a):
//   - Срабатывает каждый ход, пока висит на юните; на практике юнит умирает в
//     конце ближайшего хода после получения Мода — это намеренно (синергия для
//     добивания почти-мёртвых юнитов).
//   - Хил Героя НЕ может превысить max HP Героя.
//   - Смерть от Завещания — обычная смерть, активирует Посмертия (Эксп. батарея,
//     Второе сердце, deathrattle юнита).
//   - При связке М3+М4: юнит умирает в конце хода (М4), М3 ставит флаг возврата.
//     В Ф1 след. хода юнит возвращается с 1 ХП БЕЗ Модов (по правилам М3) — М4
//     тоже снят, цикла нет.

import { dispatchUnitDied } from '../deus/hooks.js';
import { shortHeroName } from '../../../data/heroes.js';

export const MOD_ID = 'syn_mod_zaveshanie';

// Вызывается из onEndOfTurn для каждой Модификации Завещания на живом юните-носителе.
// Возвращает true, если юнит умер (вызывающий код прекращает дальнейшую обработку
// его модов).
export function tsifrovoeZaveschanieEot(state, ownerIdx, carrier) {
  const p = state.players[ownerIdx];
  const hero = p.hero;
  // Этап 56.48 (решение фаундера «под текст»): хил = 50% от MAX hp носителя
  // (округление вверх), а не от текущего hp. carrier.base.hp учитывает Моды
  // (Защитная оболочка и пр. поднимают base.hp = max hp).
  const carrierMaxHp = carrier.base?.hp ?? carrier.current.hp;
  const heal = Math.ceil(carrierMaxHp / 2);
  const heroMaxHp = hero.base.hp;
  const before = hero.current.hp;
  hero.current.hp = Math.min(before + heal, heroMaxHp);
  const actual = hero.current.hp - before;
  state.log.add(
    `📜 ${carrier.name_ru} [${p.name}]: Цифровое завещание — гибель, ${shortHeroName(hero)} +${actual} HP ` +
    `(HP ${before}→${hero.current.hp}, хил ${heal} = 50% от max hp ${carrierMaxHp})`
  );
  // Стандартная смерть.
  carrier.current.hp = 0;
  carrier.alive = false;
  p.removeFromField(carrier);
  state.log.add(`✗ ${carrier.name_ru} [${p.name}] погибает (Завещание)`);
  dispatchUnitDied(state, {
    ownerIdx, card: carrier,
    killer: null, killerIdx: null, killerWasCounter: false
  });
  return true;
}
